import React from 'react';
import PropTypes from 'prop-types';
import './ToggleSwitch.scss';
import { useIntl } from 'react-intl';

const ToggleSwitch = ({ id, name, checked, onChange }) => {
  const intl = useIntl();
    function handleKeyPress(e) {
        if (e.keyCode !== 32) return;
        e.preventDefault();
        onChange(!checked);
    }

    return (
            <div className="custom-control">
                <input
                    type="checkbox"
                    id={id}
                    className="toggle-input"
                    checked={checked}
                    onChange={e => onChange(e.target.checked)}
                />
                <label htmlFor={id} onKeyDown={handleKeyPress} className="toggle-label">
                    <span className="toggle-switch"></span>
                    {name}
                </label>
            </div>
    );
};

ToggleSwitch.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string
};

ToggleSwitch.defaultProps = {
    id: '',
    checked: false,
    onChange: ()=> {},
    name: ''
};

export default React.memo(ToggleSwitch);
